import { ArrowCircleRightIcon, ArrowNarrowLeftIcon, CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon, XCircleIcon } from "@heroicons/react/solid";
import BigNumber from "bignumber.js";
import { useEffect, useState } from "react";
import { CoinIcon, ErrorBar, InformationBar, LoadingDialog } from "../components/CommonComponents";
import { LoadingCircleSVG } from "../components/Svgs";
import API from "../conf/API";
import { WAIdToName } from "../conf/Config";
import { AddressBook } from "../modules/AddressBook";
import DataCenter, { Calculator, QuoteCoinID, TransactionMethod } from "../modules/DataCenter";
import { Localize, LocalStr } from "../modules/localize/Localize";
import { useTrans } from "../modules/TransactionService";
import { TransactionState, WalletService, WalletTxInfo } from "../modules/WalletService"
import { request } from "../utils/request";
import { LongTimeToFullStr } from "../utils/Utils";
import TabMenu, { TabMenu2 } from '../components/TabMenu';



export const DoingTransactions = ({ addView }) => {

    const [trans] = useTrans();

    const transPanels = [];

    const l = Math.min(trans.length, 3);

    const h = "h-[" + (l * 48) + "px]";
    const ht = l == 0 ? "0px" : "" + (l * 48 + 28 + 9 + 32) + "px"

    for (let i = 0; i < l; i++) {
        const key = trans[i].orderId == 0 ? i : trans[i].orderId;
        transPanels.push(<DoingTransactions_Panel key={key} addView={addView} txInfo={trans[i]} />);
    }

    return <div className={"flex flex-col w-full "} style={{ transition: "height 500ms", height: ht }}>
        <div className="flex w-full h-[1px] bg-gray-100"></div>
        <div className="flex flex-col px-3 py-4">
            <LocalStr msg={Localize.Order.doingTransaction} className="text-xl font-semibold h-[28px]" />
            <div className={"flex flex-col mt-2 justify-end overflow-hidden " + h}>
                {transPanels}
            </div>
        </div>
    </div>
}

// coinType;
// walletAccount;
// txMethod;
// transferNet;
// amount;
// txFrom;
// txTo;
// nonce;
// transactionHash;
// orderId;
// signature;
// #gasPrice;
// #gasUsed;

const DoingTransactions_Panel = ({ addView, txInfo, onClick, showTime }) => {
    const { coinType, txFrom, txTo, walletAccount, txMethod, state, result, amount, transDate } = txInfo;
    const coin = DataCenter.getCoin(coinType);
    let method = "";


    const wallet = WAIdToName(walletAccount);
    let from = AddressBook.findAddress(txFrom)?.fromName ?? WalletService.eclipsisAddress(txFrom, 3);
    let to = AddressBook.findAddress(txTo)?.fromName ?? WalletService.eclipsisAddress(txTo, 3);
    const b = Calculator.toNumber(amount, coinType).toTrimed(2, coin.showDecimals);

    if (txMethod == TransactionMethod.Topup) {
        //充值操作，to是交易或游戏账号
        to = wallet;
        method = Localize.COMMON.Topup;
    } else if (txMethod == TransactionMethod.Withdraw) {
        //提现操作，from是交易或游戏账号
        from = wallet;
        method = Localize.COMMON.Withdraw;
    } else if (txMethod == TransactionMethod.Transfer) {
        method = Localize.COMMON.Send;
    }

    method = Localize.getMsg(method);

    let state_icon = "";
    let state_msg = Localize.getCodeMsg(Localize.Code.TransactionMethod.type, state);

    if (result == TransactionState.TRANSACTION_STATE_ERROR) {
        //出错了
        state_icon = <XCircleIcon className="w-6 h-6 mr-1 text-red-500" />
        state_msg = Localize.getCodeMsg(Localize.Code.TransactionMethod.type, result);
    } else {
        switch (state) {
            case TransactionState.TRANSACTION_STATE_SENT:
                state_icon = <CheckCircleIcon className="w-6 h-6 mr-1 text-green-500" />
                break;
            default:
                state_icon = <div className="w-6 h-6 flex items-center justify-center mr-1 text-black"> {LoadingCircleSVG} </div>
                break;
        }
    }

    const Panel = () => {
        return <div className="flex w-full items-center pb-2" onClick={e => {
            addView(Transcation_DetailView, "left", null, act => {

            }, { addView: addView, txInfo: txInfo })
        }}>
            <CoinIcon coin={coin} className="w-8 h-8 mr-2" />
            <div className="flex flex-col text-sm flex-1">
                <div className="flex items-center"><div className="font-semibold pr-1">{method}</div> {b} {coin.name}</div>
                <div className="flex items-center  text-gray-500">
                    <div className="font-semibold">{from}</div>
                    <div><ArrowCircleRightIcon className=" text-green-600 w-5 h-5 ml-1 mr-1" /></div>
                    <div className="font-semibold">{to}</div>
                </div>
            </div>

            <div className="flex flex-col justify-center">
                <div className="flex  justify-end">
                    {state_icon}
                    <div>{state_msg}</div>
                </div>
                {showTime ?
                    <div className="text-sm">{LongTimeToFullStr(transDate)}</div> :
                    null}
            </div>
        </div>
    }

    return <div className="flex w-full">
        <Panel />
    </div>
}

const Transcation_DetailView = ({ addView, fireViewAction, txInfo }) => {
    const [trans] = useTrans();

    const { coinType, txFrom, txTo, walletAccount, txMethod, state, amount, msg, result } = txInfo;
    const coin = DataCenter.getCoin(coinType);
    let method = "";
    let detail = null;

    const b = Calculator.toNumber(amount, coinType).toTrimed(2, coin.showDecimals);

    if (txMethod == TransactionMethod.Topup) {
        method = Localize.COMMON.Topup;
        detail = <DetailView_Topup txInfo={txInfo} addView={addView} />
    } else if (txMethod == TransactionMethod.Withdraw) {
        method = Localize.COMMON.Withdraw;
        detail = <DetailView txInfo={txInfo} addView={addView} />
    } else if (txMethod == TransactionMethod.Transfer) {
        method = Localize.COMMON.Send;
        detail = <DetailView txInfo={txInfo} addView={addView} />
    }

    method = Localize.getMsg(method);

    let state_icon = "";
    let state_msg = Localize.getCodeMsg(Localize.Code.TransactionMethod.type, state);
    let txtColor = "";


    if (result == TransactionState.TRANSACTION_STATE_ERROR) {
        //出错了
        state_icon = <XCircleIcon className="w-6 h-6 mr-1 text-red-500" />
        state_msg = Localize.getCodeMsg(Localize.Code.TransactionMethod.type, result);
        //出错了
        txtColor = " text-red-500 "
    } else {
        switch (state) {
            case TransactionState.TRANSACTION_STATE_SENT:
                state_icon = <CheckCircleIcon className="w-6 h-6 mr-1 text-green-500" />
                txtColor = " text-green-500 "
                break;
            default:
                state_icon = <div className="w-6 h-6 flex items-center justify-center mr-1 text-black"> {LoadingCircleSVG} </div>
                txtColor = " text-gray-500 "
                break;
        }
    }


    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">
                {Localize.getMsg(Localize.UI.TransactionDetailView.title, method)}
            </div>
        </div>
        <div className="flex flex-col w-full">
            <LocalStr msg={Localize.COMMON.Amount} className="flex w-full items-center justify-center text-sm text-gray-500 pt-3"/>
            <div className="flex w-full items-center justify-center text-xl pt-2">
                <div className="pr-2 font-semibold">{b}</div>
                <div>{coin.name}</div>
            </div>
            <div className="flex w-full items-center justify-center pt-2">
                <div>{state_icon}</div>
                <div className={txtColor}>{state_msg}</div>
            </div>
            {
                msg == "" || msg == null ? "" : <ErrorBar text={msg} />
            }
            <div className="flex w-full bg-gray-100 h-[1px] my-3"></div>
            {detail}
        </div>
    </div>
}

const DetailView = ({ addView, txInfo }) => {
    const { coinType, txFrom, txTo, walletAccount, txMethod, state, amount, transactionHash, transDate } = txInfo;
    const coin = DataCenter.getCoin(coinType);
    const quoteCoin = DataCenter.getCoin(QuoteCoinID);

    const wallet = WAIdToName(walletAccount);
    let from = AddressBook.findAddress(txFrom)?.fromName ?? WalletService.eclipsisAddress(txFrom, 3);
    let to = AddressBook.findAddress(txTo)?.fromName ?? null;
    const b = Calculator.toNumber(amount, coinType).toTrimed(2, coin.showDecimals);
    const serviceFee = Calculator.toNumber(txInfo.gasPrice, QuoteCoinID).toTrimed(2, quoteCoin.showDecimals);

    let method = "";

    if (txMethod == TransactionMethod.Topup) {
        //充值操作，to是交易或游戏账号
        to = wallet;
        method = Localize.COMMON.Topup;
    } else if (txMethod == TransactionMethod.Withdraw) {
        //提现操作，from是交易或游戏账号
        from = wallet;
        method = Localize.COMMON.Withdraw;
    } else if (txMethod == TransactionMethod.Transfer) {
        method = Localize.COMMON.Send;
    }

    const transNet = DataCenter.getBlockchina(txInfo.transferNet)?.text ?? DataCenter.blockchain().text;

    return <div className="flex flex-col w-full px-2 text-gray-500">
        <div className="flex w-full">
            <div className="flex-1">{txMethod == TransactionMethod.Transfer ?
                Localize.getMsg(Localize.COMMON.SendAccount) :
                Localize.getMsg(Localize.COMMON.withdrawAccount)}</div>
            <div className="flex w-4/6 justify-end text-black">{from}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.transferNet)}</div>
            <div className="flex w-4/6 justify-end text-black">{transNet}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1 flex items-center">{Localize.getMsg(Localize.COMMON.recvAddress)}</div>
            <div className="w-4/6 text-right text-black break-words text-xs underline" onClick={e => {
                addView(Detail_Explorer, "left", null, action => { }, { item: "address", value: txTo })
            }}>{txTo}  <span className="font-semibold">{to == null ? "" : `(${to})`}</span> </div>
        </div>
        <div className="flex w-full pt-2">
            <div className="flex-1 flex items-center">{Localize.getMsg(Localize.COMMON.signature)}</div>
            <div className="w-4/6 text-right text-black break-words text-xs underline" onClick={e => {
                addView(Detail_Explorer, "left", null, action => { }, { item: "tx", value: transactionHash })
            }}>{transactionHash}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.serviceFee)}</div>
            <div className="flex w-4/6 justify-end text-black">{serviceFee} {quoteCoin.name}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.date)}</div>
            <div className="flex w-4/6 justify-end text-black">{LongTimeToFullStr(transDate)}</div>
        </div>
    </div>

}

const DetailView_Topup = ({ addView, txInfo }) => {
    const { coinType, txFrom, txTo, walletAccount, txMethod, state, amount, transactionHash, transDate } = txInfo;
    const coin = DataCenter.getCoin(coinType);
    const quoteCoin = DataCenter.getCoin(QuoteCoinID);

    const wallet = WAIdToName(walletAccount);
    let from = AddressBook.findAddress(txFrom)?.fromName ?? null;
    let to = AddressBook.findAddress(txTo)?.fromName ?? null;
    const b = Calculator.toNumber(amount, coinType).toTrimed(2, coin.showDecimals);
    const serviceFee = Calculator.toNumber(txInfo.gasPrice, QuoteCoinID).toTrimed(2, quoteCoin.showDecimals);

    let method = "";

    if (txMethod == TransactionMethod.Topup) {
        //充值操作，to是交易或游戏账号
        to = wallet;
        method = Localize.COMMON.Topup;
    } else if (txMethod == TransactionMethod.Withdraw) {
        //提现操作，from是交易或游戏账号
        from = wallet;
        method = Localize.COMMON.Withdraw;
    } else if (txMethod == TransactionMethod.Transfer) {
        method = Localize.COMMON.Send;
    }

    const transNet = DataCenter.getBlockchina(txInfo.transferNet)?.text ?? DataCenter.blockchain().text;

    return <div className="flex flex-col w-full px-2 text-gray-500">
        <div className="flex w-full">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.topupAccount)}</div>
            <div className="flex w-4/6 justify-end text-black">{to}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.transferNet)}</div>
            <div className="flex w-4/6 justify-end text-black">{transNet}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1 flex items-center">{Localize.getMsg(Localize.COMMON.signature)}</div>
            <div className="w-4/6 text-right text-black break-words text-xs underline" onClick={e => {
                addView(Detail_Explorer, "left", null, action => { }, { item: "tx", value: transactionHash })
            }}>{transactionHash}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.serviceFee)}</div>
            <div className="flex w-4/6 justify-end text-black">{serviceFee} {quoteCoin.name}</div>
        </div>

        <div className="flex w-full pt-2">
            <div className="flex-1">{Localize.getMsg(Localize.COMMON.date)}</div>
            <div className="flex w-4/6 justify-end text-black">{LongTimeToFullStr(transDate)}</div>
        </div>
    </div>

}

const Detail_Explorer = ({ fireViewAction, item, value }) => {
    const { name, url } = WalletService.provider.getExplorer(item, value);


    return <div className="flex flex-col w-full h-full bg-white pt-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center px-4' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">
                {name}
            </div>
        </div>
        <iframe className="w-full h-full"
            src={url}
        />
    </div>
}

export const TransactionHistory_View = ({ addView, fireViewAction, openTabType = TransactionMethod.Topup }) => {
    const [history, setHistory] = useState({});
    const [currTab, setCurrTab] = useState(openTabType);
    const [loading, setLoading] = useState(true);
    const [itemListMap, setItemListMap] = useState({})
    useEffect(() => {
        request(API.wallet_trans_history(DataCenter.blockchain().key)).then(ret => {
            setLoading(false);
            if (ret.error) {
                return;
            }
            const nh = { ...history };
            ret.retObject.forEach(txInfo => {
                const info = new WalletTxInfo(txInfo);

                let h = nh[info.txMethod];
                if (h == null) {
                    h = nh[info.txMethod] = [];
                }
                h.push(info);
            })

            setHistory({ ...nh })

        })
        return () => {

        }
    }, [])

    const tabItems = [
        { type: TransactionMethod.Topup, name: Localize.getMsg(Localize.COMMON.Topup) },
        { type: TransactionMethod.Withdraw, name: Localize.getMsg(Localize.COMMON.Withdraw) },
        { type: TransactionMethod.Transfer, name: Localize.getMsg(Localize.COMMON.Send) },
    ]

    const h = history[currTab] ?? [];

    return <div className="flex flex-col w-full h-full bg-white pt-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center px-4' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">
                {Localize.getMsg(Localize.UI.TransactionHistoryView.title)}
            </div>
        </div>
        <div className="px-4">
            <InformationBar text={Localize.getMsg(Localize.UI.TransactionHistoryView.transactionHistory)} onClick={
                e => {
                    addView(Detail_Explorer, "left", null, action => { }, { item: "address", value: WalletService.walletInfo.address })
                }
            } />
        </div>
        <div className="px-4">
            <TabMenu2 tabItems={tabItems}
                currSelTab={currTab}
                isSelectedItem={(currSel, item) => {
                    return item.type == currTab
                }}
                onItemChanged={(type, item) => {
                    // setTabSelect(item.walletId);
                    // onTabItemChanged(type, item)
                    setCurrTab(type);
                }} />
        </div>
        <PagedList dataList={h}
            makeItem={data => <DoingTransactions_Panel key={data.orderId} addView={addView} txInfo={data} showTime={true} />}
            itemPerPage={20} />
        <LoadingDialog show={loading} />
    </div >
}

const PagedList = ({ dataList, makeItem, itemPerPage }) => {
    const [currPage, setCurrPage] = useState(0);

    useEffect(() => {
        setCurrPage(0);
    }, [dataList])

    let pages = Math.trunc(dataList.length / itemPerPage);
    if (dataList.length % itemPerPage != 0) {
        pages++;
    }

    const from = currPage * itemPerPage;
    let to = (currPage + 1) * itemPerPage
    if (to > dataList.length) {
        to = dataList.length;
    }
    const itemList = [];

    for (let i = from; i < to; i++) {
        itemList.push(makeItem(dataList[i]))
        if (i < to - 1)
            itemList.push(<div key={"divide_" + i} className="w-full h-[1px] bg-gray-100 my-2"></div>)
    }

    return <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex flex-col w-full h-full overflow-y-auto px-2 mt-4 mb-2">
            <div className="flex flex-col w-full flex-1 px-2">
                {itemList}
            </div>
        </div>
        {
            pages > 1 ?
                <div className="flex px-4 pb-4 justify-center items-center">
                    <div className="flex justify-end w-full" onClick={e => {
                        setCurrPage(Math.max(currPage - 1, 0))
                    }}>
                        <ChevronLeftIcon className="w-8 h-8" />
                    </div>
                    <div className="font-semibold flex">{currPage + 1}/{pages}</div>
                    <div className="flex justify-start w-full" onClick={e => {
                        setCurrPage(Math.min(currPage + 1, pages - 1))
                    }}>
                        <ChevronRightIcon className="w-8 h-8" />
                    </div>
                </div> :
                null
        }

    </div>
}